<div class="card  mt-3  mb-4">
  <div [style.opacity]="loading ? '0' : '1'">
    <div class="card-header">
      <div class="row no-gutters align-items-center">
        <div class="col-auto d-flex justify-content-end order-md-1">
          <button class="btn btn-sm icon-item icon-item-sm icon-item-hover shadow-none p-0 mr-1 ml-md-2"
                  type="button" data-event="prev">
            <span class="fas fa-arrow-left"></span>
          </button>
          <button class="btn btn-sm icon-item icon-item-sm icon-item-hover shadow-none p-0 mr-1" type="button" data-event="next">
            <span class="fas fa-arrow-right"></span>
          </button>
        </div>
        <div class="col-auto col-md-auto order-md-2 ml-5">
          <h4 class="mb-0 fs-0 fs-sm-1 fs-lg-2 calendar-title"></h4>
        </div>
        <div class="col col-md-auto d-flex justify-content-end order-md-3">
          <button class="btn btn-falcon-primary btn-sm" type="button" data-event="today">Today</button>
        </div>
        <div class="col-md-auto d-md-none">
          <hr />
        </div>
        <div class="col-auto d-flex order-md-0">
          <!--<button class="btn btn-primary btn-sm" type="button" data-toggle="modal" (click)="newLeadSearch()">
            <span class="fas fa-plus mr-2 fs-10"></span>Schedule
          </button>-->
        </div>
        <div class="col d-flex justify-content-end order-md-2">


          <!-- without filter operation without default filter -->
          <button class="btn btn-falcon-default text-600 btn-sm mr-2"
                  type="button" (click)="filterOption('Calendar')" *ngIf="(!filterModalData?.filterObj || filterModalData?.filterObj?.length==0) && (projectFilteredBgOpe==0 && localstorageVal=='')">
            <span class="fas fa-filter d-inline-block d-sm-none"
                  data-fa-transform="shrink-3 down-2"></span>
            <span class="d-none d-sm-inline-block">
              View
            </span>
          </button>
          <!---->
          <!-- after  filter  without default filter -->
          <button class="btn btn-primary btn-sm mr-2"
                  type="button"
                  *ngIf="(!filterModalData?.filterObj || filterModalData?.filterObj?.length==0) && (projectFilteredBgOpe==1 || localstorageVal!='')"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span class="fas fa-filter d-inline-block d-sm-none"
                  data-fa-transform="shrink-3 down-2"></span>
            <span class="d-none d-sm-inline-block">
              Custom view
            </span>
          </button>
          <div class="dropdown-menu dropdown-menu dropdown-menu-right" *ngIf="(!filterModalData?.filterObj || filterModalData?.filterObj?.length==0) && (projectFilteredBgOpe==1 || localstorageVal!='')"
               aria-labelledby="btnGroupVerticalDrop2" style="padding: 0.3rem 0rem; left: -25px !important; z-index: 10000 !important;">
            <a class="dropdown-item cursor-pointer" (click)="filterOption('Calendar')">Settings</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item text-danger cursor-pointer" (click)="resetFilterSelect()" *ngIf="(projectFilteredBgOpe==1 || localstorageVal!='')">Reset</a>
          </div>
          <!---->
          <!-- after filter operation with default filter -->
          <div class="dropdown">
            <button class="btn  btn-sm mr-2" *ngIf="filterModalData?.filterObj?.length>0"
                    type="button" [ngClass]="(projectFilteredBgOpe==1 ||  localstorageVal!='') ? 'btn-primary' : 'btn-light border btn-falcon-default text-600'" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <span>
                <span class="fas fa-filter d-inline-block d-sm-none"
                      data-fa-transform="shrink-3 down-2"></span>
                <span class="d-none d-sm-inline-block" *ngIf="defaultFiter==0 && (projectFilteredBgOpe==1 || localstorageVal!='')">Custom view </span>
                <span class="d-none d-sm-inline-block" *ngIf="(defaultFiter==0 && (projectFilteredBgOpe==0 && localstorageVal=='')) || (defaultFiter!=0 && (projectFilteredBgOpe==0 && localstorageVal==''))">View</span>
                <span class="d-none d-sm-inline-block" *ngIf="defaultFiter!=0 && projectFilteredBgOpe==1">{{FilterName}}</span>
              </span>
            </button>
            <div class="dropdown-menu dropdown-menu-right border py-2" *ngIf="filterModalData?.filterObj?.length>0" aria-labelledby="btnGroupVerticalDrop2" style="padding: 0.3rem 0rem; left: -25px !important; z-index: 10000 !important;">
              <span *ngIf="filterModalData?.filterObj?.length>0">
                <a class="dropdown-item cursor-pointer" *ngFor="let f of filterModalData.filterObj" [ngClass]="f.id==defaultFiter && projectFilteredBgOpe!=0 ? 'bg-drowpdown-light bold-text' : 'bg-white'" (click)="changeFilter(f)">{{f.name}}</a>
              </span>
              <div class="dropdown-divider" *ngIf="filterModalData?.filterObj?.length>0"></div>
              <a class="dropdown-item cursor-pointer" (click)="filterOption('Calendar')">Settings</a>
              <div class="dropdown-divider" *ngIf="filterModalData?.filterObj?.length>0 && projectFilteredBgOpe==1"></div>
              <a class="dropdown-item text-danger cursor-pointer" (click)="resetFilterSelect()" *ngIf="projectFilteredBgOpe==1 || localstorageVal!=''">Reset</a>
            </div>
          </div>
          <!---->


          <div class="dropdown text-sans-serif mr-md-2">
            <button class="btn btn-falcon-default text-600 btn-sm dropdown-toggle dropdown-caret-none" type="button" id="email-filter" data-toggle="dropdown" data-boundary="viewport" aria-haspopup="true" aria-expanded="false">
              <span data-view-title="data-view-title">Week View</span>
              <span class="fas fa-sort ml-2 fs--1"></span>
            </button>
            <div class="dropdown-menu dropdown-menu-right border py-2" aria-labelledby="email-filter" style="z-index:10000!important">
              <a class="dropdown-item d-flex justify-content-between" href="javascript:void(0)" data-fc-view="dayGridMonth">Month View<span><span class="fas fa-check" data-fa-transform="down-4 shrink-4"></span></span></a>
              <a class="active dropdown-item d-flex justify-content-between" href="javascript:void(0)" data-fc-view="dayGridWeek">Week View<span><span class="fas fa-check" data-fa-transform="down-4 shrink-4"></span></span></a>
              <a class="dropdown-item d-flex justify-content-between" href="javascript:void(0)" data-fc-view="timeGridDay">Day View<span><span class="fas fa-check" data-fa-transform="down-4 shrink-4"></span></span></a>
              <a class="dropdown-item d-flex justify-content-between" href="javascript:void(0)" data-fc-view="listWeek">List View<span><span class="fas fa-check" data-fa-transform="down-4 shrink-4"></span></span></a>
            </div>
          </div>


        </div>
      </div>
    </div>
    <div class="card-body p-0">
      <div id="appCalendar" style="height: 800px;"></div>
    </div>
  </div>
  <ngx-loading [show]="loading" class="z-index1000"></ngx-loading>
</div>







<!--Modal Filter Project-->
<div class="modal fade px-0 overflow-auto z-index1042" id="modalProjectFilter" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-keyboard="true">
  <div class="modal-dialog modal-width30per" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">
          View settings
        </h5>
        <button class="close" type="button" data-dismiss="modal" aria-label="Close">
          <span class="font-weight-light" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="padding:1rem 2rem!important">

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="projectType">Type</label>
              <ng-select [items]="filterModalData.typeObj"
                         bindValue="id"
                         [multiple]="true"
                         bindLabel="name"
                         [(ngModel)]="filteredDataType"
                         (change)="selecChange()">
              </ng-select>
            </div>
          </div>


          <div class="col-12 mb-2">
            <div class="form-group mb-1 mt-3 mb-07-rem">
              <label for="" class="fs-12 mb-0 text400">Assignees</label>
            </div>
            <ul class="nav avatar-group mb-0">
              <li class="nav-item dropdown" *ngFor="let asg of filteredDataAssignee_;let index = index">
                <div class="nav-link p-0 dropdown-toggle dropdown-caret-none">
                  <div class="avatar avatar-xl remove-asg " [ngClass]="{'ml-minus04rem':index>0}">
                    <img class="rounded-circle" *ngIf="asg?.img?.length>0" style="border:1px solid #fff" src="{{asg.img}}" alt="" data-toggle="tooltip" data-placement="top" title="{{asg.name}}" />
                    <span class="circle-user-icon color-white avatar-button fs-14" *ngIf="asg?.img?.length==0" data-toggle="tooltip" data-placement="top" title="{{asg.name}}"><i class="fas fa-user"></i></span>
                    <div class="overlay-remove">
                      <a (click)="activityFilteerAssignerChange(index,asg,'remove')" class="icon-remove" data-toggle="tooltip" data-placement="top" title="Remove {{asg.name}}">
                        <i class="fas fa-times"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </li>
              <li class="nav-item dropdown">
                <a class="nav-link p-0 dropdown-toggle dropdown-caret-none" id="dropDownAssignerFilter"
                   data-toggle="dropdown">
                  <span class="circle-dashed cursor-pointer" style="width: 32px; height: 32px;"><span class="fas fa-plus"></span></span>
                </a>
                <div class="dropdown-menu dropdown-md">
                  <h6 class="dropdown-header py-0 px-3 mb-0">Select Member</h6>
                  <div class="dropdown-divider"></div>
                  <div class="px-3 mb-2">
                    <input class="form-control form-control-sm" type="search"
                           placeholder="Search team member" [(ngModel)]="searchFilterAssigner" />
                  </div>
                  <ul class="list-unstyled  max-height300px overflow-y-auto">
                    <li *ngFor="let m of filterModalData.assigneeObj |filter :searchFilterAssigner ;let index=index" (click)="activityFilteerAssignerChange(index,m,'add')" [ngClass]="{'disabledLi': m.disabledAssigner==1}">
                      <a class="media align-items-center text-decoration-none hover-200 py-1 px-3 cursor-pointer">
                        <div class="avatar avatar-xl ml-minus05rem">
                          <img class="rounded-circle" *ngIf="m?.img?.length>0" src="{{m.img}}" alt="" />
                          <span class="circle-user-icon color-white avatar-button fs-14" *ngIf="!m?.img"><i class="fas fa-user"></i></span>
                        </div>
                        <div class="media-body ml-2">
                          <h6 class="mb-0">{{m.name}}</h6>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>


          <div class="col-12">
            <div class="form-group">
              <label for="projectType">Activity</label>


              <ng-select id="viewActivities" placeholder="Choose"
                         [multiple]="true"
                         [(ngModel)]="filteredDataActivities"
                         (change)="selecChange()">
                <ng-option *ngFor="let at of filterModalData.activityTypeObj" [value]="at.id" [disabled]="at.type!=filteredDataType && filteredDataType!='1,2'">
                  {{at.name}}
                </ng-option>
              </ng-select>


          
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label for="status">Status</label>
              <ng-select class="normal-select2" [items]="filterModalData.statusObj"
                         bindValue="id"
                         [multiple]="true"
                         placeholder="Choose"
                         bindLabel="name"
                         [(ngModel)]="filteredDataStatuses"
                         (change)="selecChange()">
              </ng-select>
            </div>
          </div>
        </div>
        <!--<div class="mt-2" *ngIf="filterModalData.filterObj?.length!=0">
          <b class="mt-1">Saved Views</b>
          <hr class="border-dashed border-bottom-0 mt-1 mb-3" />
        </div>
        <div class="row overflow-y-auto max-height400px" *ngIf="filterModalData.filterObj?.length!=0">
          <div class="col-12 savedFilters" style="max-height: 150px; position: inherit;">
            <table class="table table-dashboard mb-0 table-borderless fs--1 border-200 rounded-3 table-member-info">
              <tbody>
                <tr class="border-bottom border-200 cursor-pointer" *ngFor="let f of filterModalData.filterObj" (click)="showSavedFiltersDetails(f)">
                  <td style="width:5%" class="pl-2 pr-0">
                    <div class="custom-control custom-checkbox cursor-pointer">
                      <input class="custom-control-input checkbox-bulk-select-target  cursor-pointer " type="checkbox"
                             id="checkbox-ld-{{f.id}}" name="checkbox-group-customer" [(ngModel)]="f.ope" (click)="showSavedFiltersDetails(f)" />
                      <label class="custom-control-label"
                             for="checkbox-ld-{{f.id}}"></label>
                    </div>
                  </td>
                  <td style="width:90%" class="pl-0">
                    {{f.name}}
                  </td>
                  <td class="py-2 align-middle" style="width:5%">
                    <div class="dropdown text-sans-serif" id="threeNo{{f.id}}">
                      <button class="btn btn-link text-600 btn-sm dropdown-toggle btn-reveal" type="button" id="order-dropdown-0"
                              data-toggle="dropdown" data-boundary="viewport" aria-haspopup="true" aria-expanded="false">
                        <span class="fas fa-ellipsis-h fs--1"></span>
                      </button>
                      <div class="dropdown-menu dropdown-menu-right border py-0" aria-labelledby="order-dropdown-0">
                        <div class="bg-white py-2">
                          <a class="dropdown-item" (click)="editProjectFilterName(f.id)" href="javascript:void(0)">Edit</a>
                          <div class="dropdown-divider">
                          </div><a class="dropdown-item text-danger cursor-pointer" (click)="modalDelete(f.id,'filterStatus','',[])">Delete</a>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>-->
      </div>
      <div class="modal-footer">
        <!--<button class="btn btn-success btn-sm" type="button" (click)="editProjectFilterName(0)"
                *ngIf="fid==0 && (filteredDataStatuses?.length!=0 || filteredDataType?.length!=0 || filteredDataActivities?.length!=0 || filteredDataAssignee?.length!=0)">
          Save
        </button>-->
        <button class="btn btn-falcon-default btn-sm" type="button" data-dismiss="modal">Close</button>
        <button class="btn btn-primary btn-sm" type="button" (click)="getProjectFilterResult()">
          Apply
        </button>
        <!--(click)="getProjectFilterResult()"-->
      </div>
    </div>
  </div>
</div>
<!-- -->
<!--Modal Save Project Filter -->
<div class="modal fade z-index10000 px-0" id="saveProjectFilter" tabindex="-1" role="dialog" aria-labelledby="saveProjectFilter"
     data-backdrop="static" data-keyboard="false" aria-hidden="true" style="padding-left:0!important;padding-right:0!important">
  <div class="modal-dialog activity-projectFilter-width" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{newFilterModalHeader}}</h5>
        <button class="close" type="button" (click)="closeModalProjectFilter()">
          <span class="font-weight-light" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body modal-padding">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="projectFilterName">Name <span class="text-danger">*</span></label>
              <input type="text" name="Name" autocomplete="off" class="form-control form-control-sm" id="projectFilterName" tabindex="11" [(ngModel)]="projectFilterSavedModalData.name" required="required" appTrimLeft />
            </div>
          </div>
        </div>
        <div class="row" *ngIf="projectFilterSavedModalData.id!=0">
          <div class="col-12">
            <div class="form-group">
              <label for="hashCode">Calendar URL</label>
              <div class="input-group input-group-sm">
                <input type="text" name="Name" autocomplete="off"  #hashCode  class="form-control form-control-sm" id="hashCode" tabindex="12" [(ngModel)]="projectFilterSavedModalData.hashCode" disabled />
                <div class="input-group-append"><button class="btn btn-sm" style="border: 1px solid #eee;" (click)="hashCode.select();copyStringToClipboard(projectFilterSavedModalData.hashCode)"><i class="fas fa-copy"></i></button></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-falcon-default btn-sm" type="button" (click)="closeModalProjectFilter()" tabindex="14">Close</button>
        <button class="btn btn-primary btn-sm" type="button" [disabled]="projectFilterSavedModalData?.name?.length==0" (click)="saveProjectFilter()" tabindex="13">Save</button>
      </div>
    </div>
  </div>
</div>
<!-- -->
<!-- Modal Activity-->
<div class="modal fade z-index10000  px-0" style="padding-left:0!important;padding-right:0!important" id="modal_activity" tabindex="-1" role="dialog"
     aria-labelledby="modal_activity" data-backdrop="static" data-keyboard="true"
     aria-hidden="true"
     (keydown.esc)="modalActivityClose()">
  <div class="modal-dialog activity-modal-width" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="mb-0 modal-title" id="exampleModalLabel">
          {{activityModalHeader}}
          <br />
        </h5>
        <button class="close" type="button" aria-label="Close" id="X-ModalActivity" (click)="modalActivityClose()">
          <span class="font-weight-light" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body modal-body-scroll mb-6" style="padding: 1rem 2rem !important;">
        <div class="row">
          <div class="col-7 mt-2">
            <b class="mt-1">Activity details</b>
            <span class="text-muted d-block fs-12">Plan your time and take important notes</span>
          </div>
          <div class="col-5 mt-2">
            <select class="custom-select mt-2 custom-select-sm" [(ngModel)]="activityObj.status">
              <option [ngValue]="s.id" *ngFor="let s of activityObj.statusObj">{{s.name}}</option>
            </select>
          </div>
        </div>
        <hr class="border-dashed border-bottom-0 mt-1 mb-2" />
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-12">
                <div class="form-group mb-1 mb-07-rem">
                  <div class="d-flex justify-content-between align-items-center">
                    <label for="activty">Type <span class="text-danger">*</span></label>
                    <button class="btn btn-link btn-sm pr-0 pb-0 fs-12" type="button" (click)="addNewActivityTypeModal()">Add New</button>
                  </div>
                  <select class="form-control form-control-sm select2" id="activty" name="activty" [(ngModel)]="activityObj.activityTypeId" data-placeholder="Choose" title="Activity" required="required">
                    <option value="0">Choose</option>
                    <option value="{{at.id}}" *ngFor="let at of activityObj.activityTypeList">{{at.name}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="row mt-3" *ngIf="activityObj.activityTypeId!=0">
            <div class="col-lg-6 col-12">
              <div class="form-group mb-1 mb-07-rem mt-5px">
                <div class="d-flex justify-content-between align-items-center">
                  <label for="begDate" class="fs-12 mb-0 text400">Start date  <span class="text-danger" *ngIf="!activityObj.showTimeOpe || activityObj.begDate">*</span></label>
                </div>
                  <input type="date" class="form-control form-control-sm" id="begDate" [(ngModel)]="activityObj.begDate" [disabled]="activityObj.relationOpe" title="Start Date" min="" max="2099-01-01" (change)="chanheBegDate()" />
                </div>
              </div>


            <div class="col-lg-6 col-12" [hidden]="activityObj.showTimeOpe">
              <div class="form-group mb-1 mb-07-rem mt-5px">
                <div class="d-flex justify-content-between align-items-center">
                  <label for="begTime" class="fs-12 mb-0 text400">Start time <span class="text-danger">*</span></label>
                </div>
                <select class="form-control form-control-sm" id="begTime" [(ngModel)]="activityObj.begTime" (change)="changeBegTime()" [disabled]="!activityObj.begDate || activityObj.relationOpe">
                  <option [ngValue]="t.id" *ngFor="let t of startTimes">{{t.name}}</option>
                </select>
              </div>
            </div>


            <div class="col-lg-6 col-12">
              <div class="form-group mb-1 mb-07-rem  mt-5px">
                <div class="d-flex justify-content-between align-items-center">
                  <label for="endDate" class="fs-12 mb-0 text400">End date  <span *ngIf="!activityObj.showTimeOpe || activityObj.begDate" class="text-danger">*</span></label>
                </div>
                <input type="date" class="form-control form-control-sm" id="endDate" [(ngModel)]="activityObj.endDate" [disabled]="!activityObj.begDate" title="End Date" min="{{activityObj.begDate}}" max="2099-01-01" (change)="changeEndDate()" />
              </div>
            </div>


            <div class="col-lg-6 col-12" [hidden]="activityObj.showTimeOpe">
              <div class="form-group mb-1 mb-07-rem mt-5px">
                <div class="d-flex justify-content-between align-items-center">
                  <label for="endTime" class="fs-12 mb-0 text400">End time  <span class="text-danger">*</span></label>
                </div>
                <select class="form-control form-control-sm" id="endTime" [(ngModel)]="activityObj.endTime" (change)="changeEndTime()" [disabled]="!activityObj.endDate">
                  <option [ngValue]="t.id" *ngFor="let t of endTimes" [hidden]="t.ope==0">{{t.name}}</option>
                </select>
              </div>
            </div>





            <div class="col-sm-12 col-12" *ngIf="projectType==2 && activityObj.relationOpe">
              <label class="fs-12 mb-0 text400 text-warning">The start date will be set depending on the predecessor. Disable dependency to change the date manually or update the gap.</label>
            </div>
            <div class="col-12 mb-4 mt-2">
              <label class="form-check position-absolute d-inline-block cursor-pointer" for="allDayOpe">
                <input type="checkbox" class="form-check-input cursor-pointer" id="allDayOpe" [(ngModel)]="activityObj.showTimeOpe" [disabled]="projectType==2 && activityObj.relationOpe" (change)="changeAllDay()">
                <label class="form-check-label label-completed mb-2" for="allDayOpe"><span class="text-completed">All day</span></label>
              </label>
            </div>
          </div>
        </div>


        <div class="d-flex justify-content-between  mt-3">
          <label class="fs-12 mb-0 text400">Assignees</label>
          <span class="d-inline-block"  *ngIf="projectType==2">
            <select class="form-control form-control-sm" id="assignerType" [(ngModel)]="activityObj.assignerType" (change)="assignerTypeChange()">
              <option value="1">Employee</option>
              <option value="2">Trade Partner</option>
            </select>
          </span>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-12 mb-2" *ngIf="projectType==1">
                <ul class="nav avatar-group mb-0">
                  <li class="nav-item dropdown" *ngFor="let asg of activityObj.assigner;let index = index">
                    <div class="nav-link p-0 dropdown-toggle dropdown-caret-none">
                      <div class="avatar avatar-xl remove-asg " [ngClass]="{'ml-minus04rem':index>0}">
                        <img class="rounded-circle" *ngIf="asg.img?.length>0" style="border:1px solid #fff" src="{{asg.img}}" alt="" data-toggle="tooltip" data-placement="top" title="{{asg.name}}" />
                        <span class="circle-user-icon color-white avatar-button fs-14" *ngIf="asg.img?.length==0" data-toggle="tooltip" data-placement="top" title="{{asg.name}}"><i class="fas fa-user"></i></span>
                        <div class="overlay-remove">
                          <a (click)="activityAssignerChange(index,asg,'remove')" class="icon-remove" data-toggle="tooltip" data-placement="top" title="Remove {{asg.name}}">
                            <i class="fas fa-times"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="nav-item dropdown">
                    <a class="nav-link p-0 dropdown-toggle dropdown-caret-none" id="dropDownAssigner"
                       data-toggle="dropdown">
                      <span class="circle-dashed cursor-pointer" style="width: 32px; height: 32px;"><span class="fas fa-plus"></span></span>
                    </a>
                    <div class="dropdown-menu dropdown-md">
                      <h6 class="dropdown-header py-0 px-3 mb-0">Select Member</h6>
                      <div class="dropdown-divider"></div>
                      <div class="px-3 mb-2">
                        <input class="form-control form-control-sm" type="search"
                               placeholder="Search team member" [(ngModel)]="searchActAssigner" />
                      </div>
                      <ul class="list-unstyled  max-height300px overflow-y-auto">
                        <li *ngFor="let m of activityObj.assignerList |filter :searchActAssigner ;let index=index" (click)="activityAssignerChange(index,m,'add')" [ngClass]="{'disabledLi': m.disabledAssigner==1}">
                          <a class="media align-items-center text-decoration-none hover-200 py-1 px-3 cursor-pointer">
                            <div class="avatar avatar-xl ml-minus05rem">
                              <img class="rounded-circle" *ngIf="m.img?.length>0" src="{{m.img}}" alt="" />
                              <span class="circle-user-icon color-white avatar-button fs-14" *ngIf="m.img?.length==0"><i class="fas fa-user"></i></span>
                            </div>
                            <div class="media-body ml-2">
                              <h6 class="mb-0">{{m.name}}</h6>
                            </div>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="col-12 mb-2" *ngIf="projectType==2">
                <ul class="nav avatar-group mb-0">
                  <li class="nav-item dropdown" *ngFor="let asg of activityObj.assigner;let index = index">
                    <div class="nav-link p-0 dropdown-toggle dropdown-caret-none">
                      <div class="avatar avatar-xl remove-asg ml-minus04rem">
                        <img class="rounded-circle" *ngIf="asg.img?.length>0" src="{{asg.img}}" alt="" data-toggle="tooltip" data-placement="top" title="{{asg.name}}" />
                        <span class="circle-user-icon" *ngIf="asg.img?.length==0 && activityObj.assignerType==1" data-toggle="tooltip" data-placement="top" title="{{asg.name}}"><i class="fas fa-user"></i></span>
                        <span class="circle-tp-icon" *ngIf="asg.img?.length==0 && activityObj.assignerType==2" data-toggle="tooltip" data-placement="top" title="{{asg.name}}"><i class="fas fa-briefcase"></i></span>
                        <div class="overlay-remove">
                          <a (click)="activityAssignerChange_(index,asg,'remove',activityObj.assignerType)" class="icon-remove" data-toggle="tooltip" data-placement="top" title="Remove {{asg.name}}">
                            <i class="fas fa-times"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="nav-item dropdown" *ngIf="activityObj.assignerType==1">
                    <a class="nav-link dropdown-toggle dropdown-caret-none p-0" id="dropDownAssigner"
                       data-toggle="dropdown">
                      <span class="circle-dashed cursor-pointer" style="width: 32px; height: 32px;"><span class="fas fa-plus"></span></span>
                    </a>
                    <div class="dropdown-menu dropdown-md py-2">
                      <h6 class="dropdown-header py-0 px-3 mb-0">Select Member</h6>
                      <div class="dropdown-divider"></div>
                      <div class="px-3 mb-2">
                        <input class="form-control form-control-sm" type="search"
                               placeholder="Search team member" [(ngModel)]="searchActAssigner" />
                      </div>
                      <ul class="list-unstyled  max-height300px overflow-y-auto">
                        <li *ngFor="let m of activityObj.assignerList |filter :searchActAssigner ;let index=index" (click)="activityAssignerChange_(index,m,'add',1)" [ngClass]="{'disabledLi': m.disabledAssigner==1}">
                          <a class="media align-items-center text-decoration-none hover-200 py-1 px-3 cursor-pointer">
                            <div class="avatar avatar-xl ml-minus04rem">
                              <img class="rounded-circle" *ngIf="m.img?.length>0" src="{{m.img}}" alt="" />
                              <span class="circle-user-icon" *ngIf="m.img?.length==0"><i class="fas fa-user"></i></span>
                            </div>
                            <div class="media-body ml-2">
                              <h6 class="mb-0">{{m.name}}</h6>
                            </div>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>

                  <li class="nav-item dropdown" *ngIf="activityObj.assignerType==2">
                    <a class="nav-link dropdown-toggle dropdown-caret-none p-0" id="dropDowntradePartner"
                       data-toggle="dropdown">
                      <span class="circle-dashed cursor-pointer" style="width: 32px; height: 32px;" (click)="resetSearch()"><span class="fas fa-plus"></span></span>
                    </a>
                    <div class="dropdown-menu dropdown-md py-2">
                      <h6 class="dropdown-header py-0 px-3 mb-0">Select Partner</h6>
                      <div class="dropdown-divider"></div>
                      <div class="px-3 mb-2">
                        <input class="form-control form-control-sm" type="search" placeholder="Search trade partner" [(ngModel)]="searchActTradePartner" (ngModelChange)="searchTradepartner()" />
                      </div>
                      <ul class="list-unstyled  max-height300px overflow-y-auto">
                        <li *ngFor="let m of activityObj.tradePartnerList;let index=index" (click)="activityAssignerChange_(index,m,'add',2)" [ngClass]="{'disabledLi': m.disabledAssigner==1}">
                          <a class="media align-items-center text-decoration-none hover-200 py-1 px-3 cursor-pointer">
                            <div class="media-body">
                              <h6 class="mb-0">{{m.name}}</h6>
                            </div>
                          </a>
                        </li>
                      </ul>
                      <div class="px-3 fs-11 " *ngIf="activityObj?.tradePartnerList?.length==0 && searchActTradePartner.length<2">Please enter 2 or more characters</div>
                      <div class="px-3 fs-11 " *ngIf="activityObj?.tradePartnerList?.length==0 && searchActTradePartner.length>=2">No results found</div>
                    </div>
                  </li>

                </ul>
              </div>
              <div class="col-12 mt-2">
                <div class="form-group mb-1 mb-07-rem">
                  <label for="activityDescription" class="fs-12 mb-0 text600">Note</label>
                  <textarea name="activityDescription" id="activityDescription" cols="30" rows="3" class="form-control description-style" [(ngModel)]="activityObj.description" maxLength="250" appTrimLeft></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer modal-footer-fixed justify-content-end">
        <button class="btn btn-sm btn-falcon-default mr-1 f-xs-13" type="button" id="closeModalActivity" (click)="modalActivityClose()">Close</button>
        <button class="btn btn-sm btn-primary f-xs-13" type="button" id="saveModalActivity" (click)="saveActivity()"
                [disabled]="(activityObj.activityTypeId==0 || (activityObj.showTimeOpe && (activityObj.begDate && !activityObj.endDate)))  || (!activityObj.showTimeOpe && (!activityObj.begDate || !activityObj.endDate ||  !activityObj.begTime || !activityObj.endTime ))">
          <span *ngIf="!progressing">Save</span> <div *ngIf="progressing"> <div class="g_spinner"></div>Processing</div>
        </button>
      </div>
    </div>
  </div>
</div>
<!---->
<!-- Modal Delete-->
<div class="modal fade z-index10001 pr-0" style="padding-right:0!important" id="modalDelete" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
     data-backdrop="static" data-keyboard="false" aria-hidden="true" (keydown.esc)="modalDeleteClose()">
  <div class="modal-dialog modal-dialog-center modal-delete-width" role="document">
    <div class="modal-content">
      <div class="modal-header" style="border-bottom: none">
        <div class="modal-delete-header-icondiv">
          <i class="far fa-times-circle text-center modal-delete-circle-icon"></i>
        </div>
        <button class="close" type="button" data-dismiss="modal" aria-label="Close"
                (click)="modalDeleteClose()">
          <span class="font-weight-light" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p class="text-center fs-20 fw-600">Are you sure?</p>
        <p class="text-muted fs-13 pl-3 pr-3">Do you really want to delete {{delCount==1 ? 'this record' : 'these records'}}? This process can not be undone.</p>
      </div>
      <div class="modal-delete-footer">
        <button class="btn btn-sm mr-2 modal-delete-footer-cancel" type="button" data-dismiss="modal" (click)="modalDeleteClose()">Cancel</button>
        <button class="btn btn-danger btn-sm" type="button" (click)="deleteItem(delId,delType,delType2,delBulkArray)">Delete</button>
      </div>
    </div>
  </div>
</div>
<!---->
<!-- Modal Delete Filter-->
<div class="modal fade z-index10001 pr-0" style="padding-right:0!important" id="modalDeleteFilter" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
     data-backdrop="static" data-keyboard="false" aria-hidden="true" (keydown.esc)="modalDeleteFilterClose()">
  <div class="modal-dialog modal-dialog-center modal-delete-width" role="document">
    <div class="modal-content">
      <div class="modal-header" style="border-bottom: none">
        <div class="modal-delete-header-icondiv">
          <i class="far fa-times-circle text-center modal-delete-circle-icon"></i>
        </div>
        <button class="close" type="button" data-dismiss="modal" aria-label="Close"
                (click)="modalDeleteFilterClose()">
          <span class="font-weight-light" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p class="text-center fs-20 fw-600">Are you sure?</p>
        <p class="text-muted fs-13 pl-3 pr-3">Do you really want to delete {{delCount==1 ? 'this record' : 'these records'}}? This process can not be undone.</p>
      </div>
      <div class="modal-delete-footer">
        <button class="btn btn-sm mr-2 modal-delete-footer-cancel" type="button" data-dismiss="modal" (click)="modalDeleteFilterClose()">Cancel</button>
        <button class="btn btn-danger btn-sm" type="button" (click)="deleteItem(delId,delType,delType2,delBulkArray)">Delete</button>
      </div>
    </div>
  </div>
</div>
<!---->
<!--Modal Events-->
<div class="modal theme-modal fade" id="eventDetails" aria-modal="true" role="dialog" style="padding-right: 16px;">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border">
      <div class="modal-header px-card bg-light border-0 flex-between-center">
        <div>
          <h5 class="mb-0 modal-title">
            {{calendarEventData.title}}
            <br class="d-inline-block d-sm-none" />
            <div>
              <span class="badge badge rounded-capsule badge-soft-{{calendarEventData.statusColor}}  dropdown-toggle cursor-pointer" style="font-size: 13px; font-weight: 500;" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{calendarEventData.statusName}}
              </span>
              <div class="dropdown-menu">
                <span *ngFor="let st of calendarEventData.statusObj">
                  <a *ngIf="st.id!=calendarEventData.statusId" class="dropdown-item cursor-pointer" (click)="changeStatusManual('activityStatus',calendarEventData.id,st.id,st.color,st.name)">{{st.name}}</a>
                </span>
              </div>
            </div>
          </h5>
          
        </div>
        <button class="close fs-0 px-card" data-dismiss="modal" aria-label="Close">
          <span class="" data-fa-i2svg=""><svg class="svg-inline--fa fa-times fa-w-11" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512" data-fa-i2svg=""><path fill="currentColor" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path></svg></span>
        </button>

      </div>
      <div class="modal-body px-card pb-card pt-1 fs--1">
        <div class="media mt-3" *ngIf="calendarEventData.description!=''">

          <span class="fa-stack ml-n1 mr-3">
            <i class="fas fa-circle fa-stack-2x text-200"></i>
            <i class="fas fa-align-left fa-stack-1x text-primary" data-fa-transform="undefined"></i>
          </span>
          <div class="media-body">
            <h6>Note</h6>
            <p class="mb-0">
              {{calendarEventData.description}}
            </p>
          </div>
        </div>
        <div class="media mt-3">
          <span class="fa-stack ml-n1 mr-3">
            <i class="fas fa-circle fa-stack-2x text-200"></i>
            <i class="fas fa-info fa-stack-1x text-primary" data-fa-transform="undefined"></i>
          </span>
          <div class="media-body">
            <h6>Details</h6>
            <p class="mb-0 fs--1 mt-1">
              <a class="cursor-pointer" (click)="goToLead(calendarEventData.leadId,calendarEventData.projectType)"> {{calendarEventData.projectName}}</a>
            </p>
            <p class="mb-1">
              {{calendarEventData.start}}
              <br>
              {{calendarEventData.duration}}
            </p>
          </div>
        </div>

        <div class="media mt-3">
          <span class="fa-stack ml-n1 mr-3">
            <i class="fas fa-circle fa-stack-2x text-200"></i>
            <i class="fas fa-user fa-stack-1x text-primary" data-fa-transform="undefined"></i>
          </span>
          <div class="media-body" *ngIf="calendarEventData.customerName!=''">
            <h6>Customer</h6>
            <p class="mb-1">
              {{calendarEventData.customerName}}
            </p>
            <p class="mb-1"><a href="tel:{{calendarEventData.phone}}">{{calendarEventData.phone}}</a></p>
            <p class="mb-1"><a href="mailto:{{calendarEventData.email}}">{{calendarEventData.email}}</a></p>
          </div>
        </div>
        <div class="media mt-3" *ngIf="calendarEventData.location!=''">

          <span class="fa-stack ml-n1 mr-3">
            <i class="fas fa-circle fa-stack-2x text-200"></i>
            <i class="fas fa-map-marker-alt fa-stack-1x text-primary" data-fa-transform="undefined"></i>
          </span>
          <div class="media-body">
            <h6>Location</h6>
            <a class="mb-0 cursor-pointer" (click)="goToMap(calendarEventData.location)">
              {{calendarEventData.location}}
            </a>
          </div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-between bg-light px-card border-top-0">
        <div class="media mt-1 text-left">
          <div class="media-body justify-left" *ngIf="calendarEventData?.assigner?.length>0">
            <ul class="nav avatar-group mb-2">
              <li class="nav-item dropdown cursor-pointer" *ngFor="let asg of calendarEventData.assigner | slice:0:4">
                <div class="nav-link p-0 dropdown-toggle dropdown-caret-none" href="javascript:void(0)" data-toggle="dropdown">
                  <div class="avatar avatar-xl remove-asg  ml-minus04rem">
                    <img class="rounded-circle" *ngIf="asg.img?.length>0" src="{{asg.img}}" alt="{{asg.name}}" data-toggle="tooltip" data-placement="top" title="{{asg.name}}" />
                    <span *ngIf="asg.img?.length==0 && asg.type==1" data-toggle="tooltip" data-placement="top" class="circle-user-icon" title="{{asg.name}}"><i class="fas fa-user"></i></span>
                    <span *ngIf="asg.img?.length==0 && asg.type==2" data-toggle="tooltip" data-placement="top" class="circle-tp-icon" title="{{asg.name}}"><i class="fas fa-briefcase"></i></span>

                  </div>
                </div>
              </li>
              <li class="nav-item dropdown cursor-pointer">
                <div class="avatar avatar-xl ml-minus04rem cursor-pointer" *ngIf="calendarEventData.assigner.length>4">
                  <a class="nav-link dropdown-toggle dropdown-caret-none p-0" data-toggle="dropdown">
                    <div class="avatar avatar-l">
                      <div class="avatar-name rounded-circle avatar-button"><span>{{calendarEventData.assigner.length-4}}+</span></div>
                    </div>
                  </a>
                  <div class="dropdown-menu dropdown-md">
                    <h6 class="dropdown-header py-0 px-3 mb-0">Members</h6>
                    <div class="dropdown-divider"></div>
                    <div class="d-flex px-3">
                      <a *ngFor="let asg of calendarEventData.assigner" class="mr-2">
                        <div class="avatar avatar-xl">
                          <img class="rounded-circle" *ngIf="asg.img?.length>0" src="{{asg.img}}" alt="{{asg.name}}" data-toggle="tooltip" data-placement="top" title="{{asg.name}}" />
                          <span *ngIf="asg.img?.length==0 && asg.type==1" data-toggle="tooltip" data-placement="top" class="circle-user-icon" title="{{asg.name}}"><i class="fas fa-user"></i></span>
                          <span *ngIf="asg.img?.length==0 && asg.type==2" data-toggle="tooltip" data-placement="top" class="circle-tp-icon" title="{{asg.name}}"><i class="fas fa-briefcase"></i></span>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="buttons">
          <button class="btn btn-falcon-default btn-sm mr-2" (click)="editActivity(calendarEventData.id,calendarEventData.projectType)">Edit</button>
          <button class="btn btn-danger btn-sm" (click)="modalDelete(calendarEventData.id,'activityStatus','changeStatus',[])">Delete</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!---->
<!-- Modal New Activity-->
<div class="modal fade" id="modal_new_activity" tabindex="-1" role="dialog" aria-labelledby="modal_new_activity" data-backdrop="static" data-keyboard="false"
     aria-hidden="true" (keydown.esc)="modalNewActivityClose()">
  <div class="modal-dialog activity-select-modal-width" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">New Activity</h5>
        <button class="close" type="button" aria-label="Close" (click)="modalNewActivityClose()">
          <span class="font-weight-light" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body modal-padding" name="modal_new_activity_Body" id="modal_new_activity_Body">
        <div class="row">
          <div class="col-md-6 col-12">
            <div class="form-group">
              <label for="activity">Name <span class="text-danger">*</span></label>
              <input class="form-control form-control-sm" id="activity" type="text" [(ngModel)]="newActivityObj.name" required="required" appTrimLeft autocomplete="off" />
            </div>
          </div>
          <div class="col-md-6 col-12">
            <!--<div class="form-group">
              <label for="reminder">Reminder</label>
              <select class="form-control form-control-sm" id="reminderTime" [(ngModel)]="newActivityObj.defaultReminder">
                <option [ngValue]="rt.id" *ngFor="let rt of reminderTimes">{{rt.name}}</option>
              </select>
            </div>-->
          </div>
        </div>
        <div class="row">
          <div class="col-12 mt-3-4">
            <b class="modal-duration">Duration</b>
            <span class="text-muted d-block modal-duration-span">Set default duration for activity</span>
            <hr class="border-dashed border-bottom-0 mt-1 mb-3">
          </div>
          <div class="col-md-6 col-sm-6 col-12">
            <div class="form-group">
              <label for="durationDay">Day</label>
              <select class="form-control form-control-sm" id="durationDay" [(ngModel)]="newActivityObj.defaultDurationDay">
                <option [ngValue]="day.id" *ngFor="let day of durationDay_">{{day.name}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-12">
            <div class="form-group">
              <label for="durationHour">Hours</label>
              <select class="form-control form-control-sm" id="durationHour" [(ngModel)]="newActivityObj.defaultDurationHour">
                <option [ngValue]="hour.id" *ngFor="let hour of durationHour">{{hour.name}}</option>
              </select>
            </div>
          </div>
        </div>
        <!--<div class="row">
          <div class="col-12">
            <div class="form-group mb-1 mt-3 mb-07-rem">
              <label for="" class="fs-12 mb-0 text400">Default assignees</label>
            </div>
            <ul class="nav avatar-group mb-0 ml-1">
              <li class="nav-item dropdown" *ngFor="let asg of newActivityObj.assigner;let index = index">
                <div class="nav-link p-0 dropdown-toggle dropdown-caret-none">
                  <div class="avatar avatar-xl remove-asg ml-minus04rem">
                    <img class="rounded-circle" *ngIf="asg.img?.length>0" src="{{asg.img}}" alt="" data-toggle="tooltip" data-placement="top" title="{{asg.name}}" />
                    <span class="circle-user-icon" *ngIf="asg.img?.length==0" data-toggle="tooltip" data-placement="top" title="{{asg.name}}"><i class="fas fa-user"></i></span>
                    <div class="overlay-remove">
                      <a (click)="activityNewAssignerChange(index,asg,'remove')" class="icon-remove" data-toggle="tooltip" data-placement="top" title="Remove {{asg.name}}">
                        <i class="fas fa-times"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </li>
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle dropdown-caret-none p-0" id="dropDownAssigner"
                   data-toggle="dropdown">
                  <span class="circle-dashed cursor-pointer" style="width: 32px; height: 32px;"><span class="fas fa-plus"></span></span>
                </a>
                <div class="dropdown-menu dropdown-md">
                  <h6 class="dropdown-header py-0 px-3 mb-0">Select Member</h6>
                  <div class="dropdown-divider"></div>
                  <div class="px-3 mb-2">
                    <input class="form-control form-control-sm" type="search"
                           placeholder="Search team member" [(ngModel)]="searchNewActAssigner" />
                  </div>
                  <ul class="list-unstyled  max-height300px overflow-y-auto">
                    <li *ngFor="let m of newActivityObj.assignerList |filter :searchNewActAssigner ;let index=index" (click)="activityNewAssignerChange(index,m,'add')" [ngClass]="{'disabledLi': m.disabledAssigner==1}">
                      <a class="media align-items-center text-decoration-none hover-200 py-1 px-3 cursor-pointer">
                        <div class="avatar avatar-xl ml-minus04rem">
                          <img class="rounded-circle" *ngIf="m.img?.length>0" src="{{m.img}}" alt="" />
                          <span class="circle-user-icon" *ngIf="m.img?.length==0"><i class="fas fa-user"></i></span>
                        </div>
                        <div class="media-body ml-2">
                          <h6 class="mb-0">{{m.name}}</h6>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>-->
      </div>
      <div class="modal-footer">
        <button class="btn btn-falcon-default btn-sm" type="button" (click)="modalNewActivityClose()">Close</button>
        <button class="btn btn-primary btn-sm" id="btnNewActivity" type="button" [disabled]="!newActivityObj.name" (click)="saveNewActivity()">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
